const WELCOME_SIGNUP_WINDOW_SECONDS = 24 * 60 * 60;
const ALLOWED_CLOCK_SKEW_SECONDS = 5 * 60;

/**
 * Customer.io's welcome journey starts the first time `created_at` is set.
 * Keep that signup-only attribute off old profiles: otherwise installing the
 * app on a new device can backfill the attribute and welcome an existing user.
 */
export function getWelcomeSignupCreatedAt(
  createdAtUnix: number | undefined,
  nowUnix = Date.now() / 1000,
): number | undefined {
  if (
    typeof createdAtUnix !== "number" ||
    !Number.isFinite(createdAtUnix) ||
    !Number.isFinite(nowUnix)
  ) {
    return undefined;
  }

  const ageSeconds = nowUnix - createdAtUnix;
  if (
    ageSeconds < -ALLOWED_CLOCK_SKEW_SECONDS ||
    ageSeconds > WELCOME_SIGNUP_WINDOW_SECONDS
  ) {
    return undefined;
  }

  return createdAtUnix;
}
